<template>
  <div class="verify-bg">
    <div v-if="status === 'init'">
      {{ $t('pages.verify-email.verifying') }}
    </div>
    <div v-if="status === 'verified'">
      <h1>{{ $t('pages.verify-email.success') }}</h1>
      <p>
        {{ $t('pages.verify-email.success-msg') }}
      </p>
      <b-button
        variant="info"
        class="col-12 col-lg-5 search-button search-button--inverted mr-2"
        @click="$router.push({ name: 'Login' })"
      >
        {{ $t('generic.continue') }}
      </b-button>
    </div>
    <div v-if="status === 'error'">
      <h1>{{ $t('generic.error', 'Error') }}</h1>
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: "init",
      error: null,
      token: null
    }
  },
  mounted() {
    if(this.$route.query) {
      this.token = this.$route.query.token;
      this.verifyEmail();
    }
  },
  methods: {
    verifyEmail() {
      this.axios.get('/auth/verify/' + this.token)
        .then(this.status = "verified")
        .catch( error => {
          this.error = error.response.data.error;
          this.status = "error";
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .verify-bg {
    background: #02718c;
    color: white;
    padding: 85px;
    margin: -10px;
  }

   .search-button {
    background: #009090;
    border: 1px solid #009090;
    font-weight: 600;
    font-size: 0.8rem;
    padding: 4px 10px;
    transition: 0.3s ease;
    border-radius: 15px;

    &:hover {
      background: #006060;
      border: 1px solid #006060;
      transition: 0.3s ease;
    }

    &--inverted {
      background: #fff;
      color: #009090;
      border: 1px solid #fff;
      transition: 0.3s ease;
    }
 }
</style>
